import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import './App.css';
import LineChart from './LineChart';
import PredictQuality from './PredictQuality';
import PieChart from './PieChart';
import NavigationBar from './NavigationBar';
import { StreetProvider, StreetSelector } from './components/StreetSelector';
import { MultiStreetProvider, MultiStreetSelector } from './components/MultiStreetSelector';
import { useLoading } from './context/LoadingContext';
import { streetNames } from './data/streetData';
import StreetDataConsumer from './components/StreetDataConsumer'; // Consumer component
import Home from './components/Home';
import About from './components/About';
const streets = streetNames;

function App() {
  const { showLoading, hideLoading } = useLoading();

  return (
<Router>
      <div>
        <NavigationBar />
        <Routes>
          {/* Set Home component to load by default */}
          <Route path="/" element={<Navigate to="/home" />} />
          <Route path="/home" element={<Home />} />
          
          {/* Route for Line Chart */}
          <Route path="/visualize" element={
            <MultiStreetProvider>
              <StreetProvider>
                <Container className="mt-5">
                  <h2 className="text-center mb-4 border-bottom border-info pb-2" style={{color:'Navy'}}>
                  Plano City Water Quality Data Visualization Charts
                  </h2>
                </Container>
                <MultiStreetSelector streetNames={streets} />
                <LineChart />
              </StreetProvider>
            </MultiStreetProvider>
          } />
          
          {/* Route for Bar Chart */}
          <Route path="/predict" element={
            <MultiStreetProvider>
              <StreetProvider>
              <Container className="mt-5">
                  <h2 className="text-center mb-4 border-bottom border-info pb-2" style={{color:'Navy'}}>
                    Water Parameter Predictions <br/>using Machine Learning Model
                  </h2>
                </Container>
                <MultiStreetSelector streetNames={streets} />
                <PredictQuality/>
              </StreetProvider>
            </MultiStreetProvider>
          } />

          {/* Route for Pie Chart */}
          {/* <Route path="/piechart" element={
            <MultiStreetProvider>
              <StreetProvider>
                <h2>Water Quality Data Visualization - Pie Chart</h2>
                <MultiStreetSelector streetNames={streets} />
                <PieChart data={data} />
              </StreetProvider>
            </MultiStreetProvider>
          } /> */}
          <Route path="/about" element={
                <Container className="mt-5">
                <About/>
                </Container>
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
